import { defaultFill } from '../../../utils/constants';
var muiPause16 = {
    paths: [
        {
            path: 'M1,0 C1.55228475,0 2,0.455760956 2,1.00247329 L2,10.9975267 C2,11.5116309 1.61727982,11.9353477 1.11733256,11.9932556 L1,12 C0.44771525,12 0,11.544239 0,10.9975267 L0,1.00247329 C0,0.488369061 0.382720178,0.0646523491 0.882667443,0.00674437099 L1,0 Z M5,0 C5.55228475,0 6,0.455760956 6,1.00247329 L6,10.9975267 C6,11.5116309 5.61727982,11.9353477 5.11733256,11.9932556 L5,12 C4.44771525,12 4,11.544239 4,10.9975267 L4,1.00247329 C4,0.488369061 4.38272018,0.0646523491 4.88266744,0.00674437099 L5,0 Z',
            fill: defaultFill,
        },
    ],
    title: 'Pause',
    width: 8,
    height: 12,
};
var muiPause = {
    base: muiPause16,
    smIcon: muiPause16,
};
export { muiPause };
//# sourceMappingURL=pause.js.map